export enum OrientationE {
    Vertical = "Vertical",
    Horizontal = "Horizontal"
}